/* eslint-disable react/prop-types */
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { enrollInBatch } from '@actions/batches';
import BatchCardNew from '@comp/BatchCard/AquillaBatchCardNew';
import Dynamic from '@base/Dynamic/Dynamic';
import { useState } from 'react';
import { useSnackbar } from '@stores/snackbar';
import { getCourseEnrollMessage } from '@constants/index';
import useProfileFeed from '@api/hooks/profile/useProfileFeed';
import { useSelectedGoalUID } from '@api/hooks/topology/useSelectedGoal';
import useIsRecordedGoal from '@hooks/useIsRecordedGoal';

const Dialog = Dynamic(() => import('@comp/Dialog/Dialog'));

const BatchWrapper = ({
  batchUID,
  batchData,
  username,
  actionButtons = [],
  as,
  onClick,
  _index
}) => {
  const dispatch = useDispatch();
  const { open: showSnackbar } = useSnackbar();

  const { mutate: refetchProfileFeed } = useProfileFeed(username);

  const [batchUnEnrollModalOpen, setUnEnrollModalOpen] = useState(false);
  const onCloseBatchUnenrollModal = () => setUnEnrollModalOpen(false);
  const selectedGoalUID = useSelectedGoalUID();
  const { uid: goalUID, name: goalName } = batchData?.goal || {};
  const isRecordedGoal = useIsRecordedGoal(goalUID);

  const sendEvent = () => {};

  const toggleBatchEnroll = async (batchUid, isEnrolled) => {
    if (isEnrolled) {
      setUnEnrollModalOpen(true);
    } else {
      sendEvent('educatorProfile-batchEnroll');
      await dispatch(enrollInBatch(batchUid, !isEnrolled));
      refetchProfileFeed();
      showSnackbar({
        message: getCourseEnrollMessage({
          type: 'Courses',
          goalUID,
          selectedGoalUID,
          goalName,
          isRecordedGoal
        }),
        type: 'success'
      });
    }
  };

  const acceptOnClickBatch = () => {
    sendEvent('educatorProfile-batchUnEnroll');
    dispatch(enrollInBatch(batchUID, false));
    setUnEnrollModalOpen(false);
    setTimeout(() => refetchProfileFeed(), 500);
  };

  return (
    <>
      <BatchCardNew
        index={_index}
        key={batchUID}
        hideEnroll
        batch={batchData}
        toggleEnroll={toggleBatchEnroll}
        firstAuthorUsername={username}
        dataAnalytics="educatorProfile"
        as={as}
        actionButtons={actionButtons}
        onClick={onClick}
      />
      <Dialog
        onClose={onCloseBatchUnenrollModal}
        dialogState={batchUnEnrollModalOpen}
        heading="Are you sure you want to unenroll?"
        message="All courses from this batch will be removed from your schedule and you will stop receiving updates related to this batch"
        acceptLabel="Unenroll"
        rejectLabel="Cancel"
        acceptOnClick={acceptOnClickBatch}
        rejectOnClick={onCloseBatchUnenrollModal}
      />
    </>
  );
};

export default BatchWrapper;

BatchWrapper.propTypes = {
  username: PropTypes.string.isRequired
};
